<template>
    <div class="section">
        <div class="container">
            <div class="row justify-content-md-center">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <Header :client="client"></Header>       
                    <CenterModal :variant="variant" :msg="errorMgs" :visible="ShowError">
                    <div class="d-flex justify-content">
                      <img src="../assets/tickme.png" style="width: 100px;" />
                      <div class="ml-3">
                        <h3>Thank You!</h3>
                        <p>Your Ticket ID is <a :href="'https://xtservicedesk.com/support/tickets/view/'+ticket.id" target="_blank">{{ticket.my_ticket_type}}-{{ticket.id}}</a></p>
                      </div>
                    </div>
                    </CenterModal>             
                </div>
            </div>
            <form ref="taskform" @submit.prevent="submitForm" method="POST" action="" enctype="multipart/form-data">
                <div class="taskform">
                    <div class="title">
                        <h5 class="title">Create A New Support Ticket</h5>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="col-form-label">Type Of Ticket</label><br />
                                <label for="ist_1"><input type="radio" id="ist_1" v-model="formData.incident_type" :value="1" /> Request</label>&nbsp;&nbsp;&nbsp;
                                <label for="ist_2"><input type="radio" id="ist_2" v-model="formData.incident_type" :value="2" /> Incident</label>&nbsp;&nbsp;&nbsp;
                                <label for="ist_3"><input type="radio" id="ist_3" v-model="formData.incident_type" :value="3" /> Change</label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="col-form-label">Choose Project</label>
                                <select class="form-control" v-model="formData.projectid">
                                    <option v-for="option in projects" :key="option.id" :value="option.id">
                                        {{ option.project_name }}
                                    </option>
                                </select>
                            </div>
                        </div>                        
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group" style="position:relative;">
                            <label class="col-form-label" for="requester_name">Requester Name <span class="text-danger">*</span></label>
                            <input
                              id="requester_name"
                              class="form-control"
                              type="text"
                              placeholder="Choose your name"
                              autocomplete="off"
                              v-model="requesterQuery"
                              @input="showRequesterDropdown = true"
                              @focus="showRequesterDropdown = true"
                              @keydown.down.prevent="focusNext"
                              @keydown.up.prevent="focusPrev"
                              @keydown.enter.prevent="selectHighlighted"
                            />
                            <span class="invalid-error" v-if="v$.formData.requester_name.$error"> {{ v$.formData.requester_name.$errors[0].$message }} </span>

                            <ul v-if="showRequesterDropdown && filteredUsers.length" class="list-group" style="position:absolute;z-index:50;max-height:200px;overflow:auto;width:100%;">
                              <li v-for="(option, idx) in filteredUsers" :key="option.id + '-' + idx" class="list-group-item list-group-item-action"
                                :class="{active: idx === highlightedIndex}"
                                @mousedown.prevent="selectRequester(option)">
                              {{ option.full_name }}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                              <label class="col-form-label" for="requester_email">Requester Email</label>
                                  <input type="email" id="requester_email" class="form-control" v-model="formData.requester_email" readonly />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="col-form-label" for="subject">Short Description <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="formData.subject" id="subject" placeholder="Short Description" value="" />
                                <span class="invalid-error" v-if="v$.formData.subject.$error"> {{ v$.formData.subject.$errors[0].$message }} </span>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label">Detailed Description <span class="text-danger">*</span></label>
                                <textarea v-model="formData.description" rows="3" id="description"
                                    placeholder="Detailed Description. . ." class="form-control"></textarea>
                                    <span class="invalid-error" v-if="v$.formData.description.$error"> {{ v$.formData.description.$errors[0].$message }} </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label">Priority</label>
                                <select v-model="formData.preority" id="preority" class="form-control">
                                    <option value="Low">Low</option>
                                    <option value="Medium">Medium</option>
                                    <option value="High">High</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label">Upload Files</label>
                                <input type="file" class="form-control" id="attachment" name="attachment"
                                    @change="onFileUpload" ref="attachment" multiple />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                          <div class="form-group">
                              <label class="col-form-label">Enter Client PIN</label>
                              <input type="password" maxlength="4" v-model="formData.mpin" class="form-control" value="{{ formData.mpin }}" @keypress="numbersOnly" />
                              <span class="invalid-error" v-if="v$.formData.mpin.$error"> {{ v$.formData.mpin.$errors[0].$message }} </span>
                          </div>
                      </div>
                  </div>                    
                </div>
                <div class="text-center py-3 bg-light d-flex justify-content-around">
                    <button type="submit" id="add-task-button" class="btn btn-primary" :disabled="isSubmitted">{{btnText}}</button>
                    <button type="button" class="btn btn-secondary btn-rounded" @click="resetForm">Reset</button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import Header from '../components/Header.vue'
import CenterModal from '../views/modal/CenterModal.vue'
import useValidate from '@vuelidate/core'
import { required, helpers, minLength } from '@vuelidate/validators'
export default {
  components: {
    Header, CenterModal
},
  data () {
    return {
      ShowError: false,
      variant: "success",
      errorMgs: "Ticket Success Header",
      btnText: "Create Ticket",
      ticket: [],
      client: [],
      projects: [],
      users: [],
      formErrors: [],
      v$: useValidate(),
      formData: {
        incident_type: 2,
        projectid:'',
        requester_name: '',
        requester_email: '',
        subject: '',
        description: '',
        preority: 'Low',
        FILE: [],
        mpin: ''
      },
      requesterQuery: '',
      showRequesterDropdown: false,
      highlightedIndex: -1,
      isSubmitted: false
    }
  },
  validations: {
    formData: {
      requester_name: {
        required: helpers.withMessage('Please select your name', required)
      },
      subject: {
        required: helpers.withMessage('Please enter short description', required)
      },
      description: {
        required: helpers.withMessage('Please enter detailed description', required)
      },
      mpin: {
        required: helpers.withMessage('Please enter your PIN', required),
        minLength: helpers.withMessage('Please Enter 4 Digit PIN', minLength(4)),
      }
    }
  },
  mounted () {        
    fetch('https://xtservicedesk.com/api/v1/client/' + this.$route.params.client_id)
      .then((res) => res.json())
      .then((result) => {
        this.client = result.data
        this.projects = result.data.active_projects
        this.users = result.data.client_users
        this.formData.projectid = this.projects.length > 0 ? this.projects[0].id : null;
        // default to no requester selected so user can choose their name
        this.formData.requester_name = '';
        this.requesterQuery = '';
        this.formData.requester_email = '';
      })
  },
  watch: {
    'formData.requester_name': function (newVal) {
      const user = this.users.find(u => u.id === newVal)
      this.formData.requester_email = user ? user.email : ''
      this.requesterQuery = user ? user.full_name : ''
    }
  },
  computed: {
    filteredUsers () {
      const defaultOption = { id: '', full_name: 'Choose your name', email: '' }
      if (!this.requesterQuery) return [defaultOption].concat(this.users)
      const q = this.requesterQuery.toLowerCase()
      const matches = this.users.filter(u => (u.full_name || '').toLowerCase().includes(q))
      // if query exactly matches default label, show it as first option
      if ('choose your name'.includes(q) && !matches.find(m => m.full_name === defaultOption.full_name)) {
        return [defaultOption].concat(matches)
      }
      return matches
    }
  },
  methods: {
    focusNext () {
      if (!this.filteredUsers.length) return
      this.highlightedIndex = Math.min(this.highlightedIndex + 1, this.filteredUsers.length - 1)
    },
    focusPrev () {
      if (!this.filteredUsers.length) return
      this.highlightedIndex = Math.max(this.highlightedIndex - 1, 0)
    },
    selectHighlighted () {
      if (this.highlightedIndex >= 0 && this.highlightedIndex < this.filteredUsers.length) {
        this.selectRequester(this.filteredUsers[this.highlightedIndex])
      }
    },
    selectRequester (option) {
      // if default option selected, clear selection
      if (!option.id) {
        this.formData.requester_name = ''
        this.formData.requester_email = ''
        this.requesterQuery = ''
      } else {
        this.formData.requester_name = option.id
        this.formData.requester_email = option.email || ''
        this.requesterQuery = option.full_name || ''
      }
      this.showRequesterDropdown = false
      this.highlightedIndex = -1
    },
    numbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onFileUpload (event) {
      let files=event.target.files;
      Object.values(files).forEach(file => {
        this.formData.FILE = file        
      });
      console.log(this.formData.FILE)
    },
    submitForm: function () { 
      this.v$.$validate()
      if (!this.v$.$error) {
        let formData1 = new FormData();      
        formData1.append('incident_type', this.formData.incident_type)
        formData1.append('project_id', this.formData.projectid)
        formData1.append('requester_name', this.formData.requester_name)
          formData1.append('requester_email', this.formData.requester_email)
        formData1.append('subject', this.formData.subject)
        formData1.append('description', this.formData.description)
        formData1.append('preority', this.formData.preority)
        formData1.append('mpin', this.formData.mpin)
        let files = this.$refs.attachment.files
        for(var i = 0; i < files.length; i++ ){
          let file = files[i];
          formData1.append('attachment[' + i + ']', file);
        }
        //formData1.append('attachment', this.formData.FILE)
        this.sendForm(formData1)
      }else{
        console.log(this.v$)
      }     
    },
    resetForm: function(){
      this.formData.incident_type=2;
      this.formData.projectid = this.projects.length ? this.projects[0].id : '';
      this.formData.requester_name=this.users.length ? this.users[0].id : '';
      const initialUser = this.users.length > 0 ? this.users.find(u => u.id === this.formData.requester_name) : null
      this.formData.requester_email = initialUser ? initialUser.email : ''
      this.formData.subject='';
      this.formData.description='';
      this.formData.preority='Low';
      this.formData.mpin='';
      this.$refs.taskform.reset();
      this.v$.$reset()
    },
    sendForm: function (formData1){
      var resStatus = 0
      this.isSubmitted = false
      this.btnText= "Creating request...";
      fetch('https://xtservicedesk.com/api/v1/client/' + this.$route.params.client_id + '/insident-form-save', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        body: formData1
      }).then(res => {
        resStatus = res.status
        return res.json()
      }).then(res => {
        var message=""
        var type='error'
        switch (resStatus) {
          case 200:
            message=res.message
            this.ticket=res.data
            type='success'
            this.resetForm()
            this.ticket = res.data
            this.ShowError = true
            this.errorMgs= res.message
            break
          case 201:
            message=res.message
            break
          case 401:
            message=res.message
            break
          case 404:
            message=res.message
            break
          case 422:
            message += "<h5>"+res.message+"</h5>"
            var pele=''
            var data=res.data;
            Object.keys(data).forEach(function(key) {
              pele+="<p>"+key+": "+ data[key].message+"</p>"
            });
            message= message+pele            
            break
          case 500:
            message="Server Error, Try aganin"
            break
          default:
            message="Unhandled"
            break
        }
        this.$toast.open({
          message: message,
          type: type,
          position: 'top-right'
        })
      }).catch(err => {
        this.$toast.open({
            message: err,
            type: 'error',
            position: 'top-right'
          })
      }).finally(() => {
          // Enable the button after the fetch request is complete (success or failure)
          this.isSubmitted = false;
          this.btnText= "Create Request";
        });    
    }
  }
}
</script>
